export const blockIconsCommunicationGTranslateNew = (
	<span className='material-symbols-outlined'>g_translate</span>
);
